import * as Yup from 'yup';
import swal from "sweetalert2";
import moment from 'moment/moment';
import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Modal, Row, Table } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import referralService from "../../service/ReferralService";
import { config } from "../../config/config";
import { Form as FForm, Field, Formik, ErrorMessage, useFormikContext } from "formik";
import productService from '../../service/ProductService';
import userService from '../../service/UserService';
import { ProductStatus } from '../../common/constant';

export const ViewProductDetail = () => {
  const navigate = useNavigate();

  const { id } = useParams();
  const [productDetails, setProductDetails] = useState({});
  const [validator, serValidator] = useState();
  
  useEffect(() => {
    fetchProductDetails();
  }, [])

  const fetchProductDetails = async () => {
    const response = await productService.getDetail(id);
    if (response.status == 200) {
        const productDetail = response.data.data.product;
        setProductDetails(productDetail)
    }
  }

  const fetchValidatorDetail = async (id) => {
    // const response = await userService.getOne(id);
    // if (response.status == 200) {
    //     serValidator(response.data.data)
    // }
  }

 

  return (
    <>
      <div className="dashboard-main-area">
        <Container fluid>
          <div className="dashboard-area-heading management-heading">
            <Row className="row justify-content-center align-items-center mb-2">
              <Col md={12}>
                <div className="d-flex justify-content-between mb-2">
                  <div className="d-flex referral-details">
                    <h2 className="user-info-heading"><i className="fa fa-angle-left" aria-hidden="true" onClick={() => navigate('/products')}></i>Product Details</h2>
                  </div>
                </div>
              </Col>
              <Row>
                <Col md={6}>
                  <div className="referral-detail-body">
                    <h6>Product Name</h6>
                    <p>{ productDetails?.name }</p>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="referral-detail-body">
                    <h6>Proudct Description</h6>
                    <p>{ productDetails?.description || 'NA'}</p>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="referral-detail-body">
                    <h6>Category </h6>                    
                    <p>{productDetails?.category?.name}</p>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="referral-detail-body">
                    <h6>Price</h6>
                    <p>{ productDetails?.price}</p>
                  </div>
                </Col>
                <Col md={6}>
                  <div className="referral-detail-body">
                    <h6>Product Location</h6>
                    <p>{ productDetails?.address}</p>
                  </div>
                </Col>
                <Col md={12}>
                  <div className="unit-switchboard-area">
                    {productDetails?.images?.length > 0 && (
                        productDetails.images.map((media, index) => (
                            <div key={index}>
                            <div className="unit-switchboard-inner">
                                <img src={config.resourceUrl.concat(media)} />
                                <p>User Images</p>
                            </div>
                            </div>
                        ))
                    )}
                  </div>
                </Col>
                {productDetails?.validatorId?.fullName  && (
                    <>
                    <div className="mb-2">
                        <h4 className="fw-bold text-primary">Validation Details</h4>
                    </div>
                    <Row className="pb-4 border border-2 border-primary rounded">
                        <Col md={6}>
                            <div className="referral-detail-body">
                            <h6>Validator Name</h6>
                            <p>{ validator?.fullName}</p>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="referral-detail-body">
                            <h6>Validator Phone</h6>
                            <p>{ validator?.phone}</p>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="referral-detail-body">
                            <h6>Price Validation</h6>
                            <p>{ productDetails?.priceValidation}</p>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div className="referral-detail-body">
                            <h6>Validator Comments</h6>
                            <p>{ productDetails?.validatorComments}</p>
                            </div>
                        </Col>
                        <Col md={12}>
                            <div className="unit-switchboard-area">
                                {productDetails?.validationImages?.length > 0 && (
                                    productDetails.validationImages.map((media, index) => (
                                        <div key={index}>
                                        <div className="unit-switchboard-inner">
                                            <img src={config.resourceUrl.concat(media)} />
                                            <p>Validator Images</p>
                                        </div>
                                        </div>
                                    ))
                                )}
                            </div>
                        </Col>                            
                    </Row>             
                    </>
                )}
              </Row>
            </Row> 

          </div>

        </Container>
      </div>

    </>
  )
};